/**
 * 商城专场信息维护
 */
import React from 'react';

import { Row, Col, Input, Button, Tooltip, Icon } from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';

//专区编辑
import SpecialEdit from './SpecialEdit';
//专区商户配置
import SpecialMember from './SpecialMember';
//专区车辆配置
import SpecialVehicle from './SpecialVehicle';


class SpecialIndex extends React.Component {

    columns = [{
        title: '专场名称',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '专区类型',
        dataIndex: 'type',
        width: '10%',
        format: { 0: "商户专区", 1: "活动专区", 2: "标识专区" }
    }, {
        title: '活动开始时间',
        dataIndex: 'startTime',
        width: '15%',
    }, {
        title: '活动结束时间',
        dataIndex: 'endTime',
        width: '15%',
    }, {
        title: '显示顺序',
        dataIndex: 'sequence',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record)} />
                </Tooltip>
                {
                    record.type === 0 ?
                        <Tooltip title="专区商户设置">
                            <Icon type="team" className="table-operate-icon" onClick={this.updateSpecialMember.bind(this, record)} />
                        </Tooltip>
                        : <Tooltip title="专区车辆设置">
                            <Icon type="car" theme="filled" className="table-operate-icon" onClick={this.updateSpecialVehicle.bind(this, record)} />
                        </Tooltip>
                }
            </div>
        ),
    }];

    state = {
        loadData: '',
        queryData: {},

        visible: false,
        editData: {},

        loadingVisible: false,    //遮罩

        specialMemberVisible: false,
        specialVehicleVisible: false,
    };

    // constructor(props) {
    //     super();
    //     this.specialMember = React.createRef();
    // }

    //添加专场
    add = () => {
        this.setState({ visible: true, editData: {} });
    }

    update = (info, e) => {
        let data = { type: info.type };
        //读取专区入口缩略图
        http.post({
            url: '/common/getThumbnailImage',
            data: { url: info.enterImage },
            success: (enter) => {
                data.enter = { image: enter, imageUrl: info.enterIamge };
                //读取专区展示页面缩略图
                http.post({
                    url: '/common/getThumbnailImage',
                    data: { url: info.displayImage },
                    success: (display) => {
                        data.display = { image: display, imageUrl: info.displayIamge };
                        this.editRef.initEdit(data);
                        this.setState({ visible: true, editData: info });
                    }
                });
            }
        });
    }

    delete = (info, e) => {
        messager.confirm("是否删除该专区信息？", () => {
            http.post({
                url: '/mallSpecial/deleteSpecial',
                data: { id: info.id },
                success: (res) => {
                    this.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }


    updateSpecialMember = (info, e) => {
        this.specialMember.initData(info.id,
            (res) => { this.setState({ editData: info, specialMemberVisible: true }) }
        );
    }

    updateSpecialVehicle = (info, e) => {
        this.specialVehicle.initData(info.id,
            (res) => { this.setState({ editData: info, specialVechileVisible: true }) }
        );
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value
        this.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="活动名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }}
                                />
                                <Button type="primary" onClick={this.add} style={{ "float": "right" }}>新增</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/mallSpecial/findSpecialPage"
                    columns={this.columns}
                    loadData={(func) => { this.loadData = func }}
                />
                <SpecialEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false }) }}
                    editData={this.state.editData}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                    onRef={(ref) => { this.editRef = ref }}
                />
                <SpecialMember
                    visible={this.state.specialMemberVisible}
                    onCancel={() => { this.setState({ specialMemberVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    ref={(ref) => { this.specialMember = ref }}
                />
                <SpecialVehicle
                    visible={this.state.specialVechileVisible}
                    onCancel={() => { this.setState({ specialVechileVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    ref={(ref) => { this.specialVehicle = ref }}
                />

                <Loading visible={this.state.loadingVisible} message="加载中，请稍候..." />
            </div>
        )
    }
}

export default SpecialIndex;